import React, { useEffect, useState } from 'react'
import { Row, Col, SelectPicker } from 'rsuite'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function InputSelectForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  searchable = true,
  skipValidate,
  onChange = () => {},
  ...props
}) {
  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const disabled = props.disabled || false
  const [inputValue, setInputValue] = useState(props.value || schema?.value || '')
  const placeholder = props.placeholder || schema?.hint || `เลือก ${schema?.label || ''}`

  const label = props?.label || schema?.label

  useEffect(() => {
    var value = props.value || schema?.value || ''
    if (props.exValue) {
      value = props.value || ''
    }

    setInputValue(value)
    setValue(keyName, value)
  }, [props.value, schema])

  useEffect(() => {
    if (props.refreshValue) {
      var value = props.value || schema?.value || ''
      if (props.exValue) {
        value = props.value || ''
      }

      setInputValue(value)
      setValue(keyName, value)
    }
  }, [props.refreshValue])

  return (
    <>
      {schema && (
        <Row style={{ ...props.style }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {!props.hideLabel && label && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <p>
                {requiredFiled(skipValidate ? [] : schema.validators, `${label} ${index || ''}`)}
              </p>
            </Col>
          )}
          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}
          <Col
            xs={24}
            sm={24}
            md={inputMdlg}
            lg={inputMdlg}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={disabled || skipValidate ? {} : isValidators(schema.validators)}
              defaultValue={inputValue}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.options}
                    value={inputValue || props.value}
                    block
                    searchable={searchable}
                    disabled={disabled || schema.disabled}
                    placeholder={placeholder}
                    onChange={(value) => {
                      props.onChange(value)
                      setInputValue(value)
                      onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
